export enum ButtonVariants {
    'primary',
    'secondary',
    'square',
    'squareInverted',
}
